import React, { FC } from 'react'

import { Typography } from '@smarty-nx/ds'

import { content } from './page-not-found-message.content'
import classes from './page-not-found-message.module.scss'
import { CONFIG } from '../../config'
import ExclamationMark from '../../static/images/exclamationMark.svg'
import { SiteContainer } from '../shared'

export const PageNotFoundMessage: FC = () => (
  <SiteContainer>
    <div className={classes.container}>
      <img
        className={classes.image}
        src={ExclamationMark}
        alt={content.imageAlt}
        data-testid="404-warning"
      />
      <Typography
        component="h1"
        variant="Kollektif/Mega"
        className={classes.heading}
        data-testid="404-title"
      >
        {content.title}
      </Typography>
      <Typography
        variant="Kollektif/Small"
        className={classes.paragraph}
        data-testid="404-message"
      >
        {content.message}
      </Typography>
      <Typography
        variant="Kollektif/Small"
        className={classes.paragraph}
        data-testid="404-signoff"
      >
        {content.signoff}
      </Typography>
      <Typography variant="Kollektif/Small" className={classes.paragraph}>
        {content.goToWebsitePrefix}
        <a href={CONFIG.MARKETING_URL} data-testid="go-to-website-link">
          {content.goToWebsiteLabel}
        </a>
      </Typography>
    </div>
  </SiteContainer>
)
